// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "core.ruffle." + {"159":"f0575de789e96381e466","339":"e4c416130e5620dc2233"}[chunkId] + ".js";
};